import React, { FC } from "react";
// @ts-ignore
import { Link } from "react-scroll";

const Footer: FC = () => {
    return (
        <footer className="footer">
            <div className="footer__logo">
                <h3>CrossGYM</h3>
            </div>
            <ul className="footer__menu">
                <li className="footer__menu-item">
                    <Link
                        to="about"
                        smooth={true}
                        className="footer__menu-link"
                    >
                        Про нас
                    </Link>
                </li>
                <li className="footer__menu-item">
                    <Link
                        to="memberships"
                        smooth={true}
                        className="footer__menu-link"
                    >
                        Абонементи
                    </Link>
                </li>
                <li className="footer__menu-item">
                    <Link
                        to="trainers"
                        smooth={true}
                        className="footer__menu-link"
                    >
                        Тренери
                    </Link>
                </li>
                <li className="footer__menu-item">
                    <Link
                        to="halls"
                        smooth={true}
                        className="footer__menu-link"
                    >
                        Зали
                    </Link>
                </li>
                <li className="footer__menu-item">
                    <a
                        href="https://t.me/crossgym_kr"
                        className="footer__menu-link"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <img
                            width="24"
                            height="24"
                            src="https://img.icons8.com/ios-glyphs/30/ffffff/telegram-app.png"
                            alt="telegram-app"
                        />
                    </a>
                </li>
                <li className="footer__menu-item">
                    <a
                        href="https://www.instagram.com/crossgym_baza_team/"
                        className="footer__menu-link"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <img
                            width="24"
                            height="24"
                            src="https://img.icons8.com/material-outlined/24/ffffff/instagram-new--v1.png"
                            alt="instagram-new--v1"
                        />
                    </a>
                </li>
            </ul>
        </footer>
    );
};

export default Footer;
